import { useTranslation } from 'react-i18next';
import { Button } from '@hostfully/ui-components';
import useBackToLogin from '@/hooks/useBackToLogin';
import {
  PublicFormButtonContainer,
  PublicFormSubtitle,
  PublicFormTitle,
} from '@/pages/_layouts/publicLayout/publicForm.styles';

const RequestSentSection = () => {
  const { t } = useTranslation();
  const handleBackToLogin = useBackToLogin();

  return (
    <div data-testid="request-sent">
      <PublicFormTitle data-testid="request-sent-title">
        {t('pageForgotPassword.requestSentTitle')}
      </PublicFormTitle>
      <PublicFormSubtitle data-testid="request-sent-subtitle">
        {t('pageForgotPassword.requestSentSubtitle')}
      </PublicFormSubtitle>
      <PublicFormButtonContainer>
        <Button
          data-testid="request-sent-back-to-login"
          size="large"
          onClick={handleBackToLogin}
        >
          {t('pageForgotPassword.backToLogin')}
        </Button>
      </PublicFormButtonContainer>
    </div>
  );
};

export default RequestSentSection;
